// extracted by mini-css-extract-plugin
module.exports = {"handle":"style_handle__vEBgG"};